import { useEffect } from 'react';

interface SeoHeadProps {
  activeView: string;
}

const VIEW_SEO_CONFIG: Record<string, { title: string; description: string }> = {
  dashboard: {
    title: 'Дашборд & Аналитика — Clientix ИИ-CRM',
    description: 'Обзор ключевых показателей продаж, активности ИИ-автопилота и статистики сообщений.'
  },
  chats: {
    title: 'Диалоги & Мультичат — Clientix',
    description: 'Мультиканальный чат для работы с клиентами из Telegram, WhatsApp и веб-виджета с поддержкой ИИ.'
  },
  requests: {
    title: 'Сделки & Воронка продаж — Clientix',
    description: 'Канбан-доска сделок, отслеживание этапов воронки и автоматическое создание лидов из чатов.'
  },
  warehouse: {
    title: 'Складской учет & Товары — Clientix',
    description: 'Управление номенклатурой товаров, остатками на складе и ценами для ИИ-консультаций.'
  },
  ai: {
    title: 'Настройка ИИ-Агента & Автопилота — Clientix',
    description: 'Обучение ИИ на базе знаний компании, настройка тональности ответов и автопилота продаж.'
  },
  integrations: {
    title: 'Интеграции Telegram, WhatsApp, Авито — Clientix',
    description: 'Подключение каналов связи, мессенджеров и платежных систем в 1 клик.'
  },
  billing: {
    title: 'Тарифы & Подписка — Clientix ИИ-платформа',
    description: 'Выбор подходящего тарифного плана для автоматизации продаж вашего бизнеса.'
  }
};

export default function SeoHead({ activeView }: SeoHeadProps) {
  useEffect(() => {
    const config = VIEW_SEO_CONFIG[activeView] || {
      title: 'Clientix — ИИ-платформа & CRM для автоматизации продаж',
      description: 'Умная ИИ-CRM платформа для бизнеса: ИИ-автопилот ответов клиентам 24/7 в Telegram и WhatsApp.'
    };

    document.title = config.title;

    let metaDesc = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = config.description;

    let ogTitle = document.querySelector<HTMLMetaElement>('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.content = config.title;
    }

    let ogDesc = document.querySelector<HTMLMetaElement>('meta[property="og:description"]');
    if (ogDesc) {
      ogDesc.content = config.description;
    }
  }, [activeView]);

  return null;
}
